import { render, staticRenderFns } from "./OfficeAddressList.vue?vue&type=template&id=c4af060e&scoped=true&"
import script from "./OfficeAddressList.vue?vue&type=script&lang=js&"
export * from "./OfficeAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4af060e",
  null
  
)

export default component.exports